import { Injectable, ComponentFactoryResolver } from "@angular/core";
import { CoreLogService } from "../log.service";
import { DynamicLoader } from "./systemComponentDynamicLoader";
import * as _ from "lodash";

/** Komponentenfunktionen */
@Injectable()
export class SystemComponent {

    constructor(private _coreLogService: CoreLogService) {
    }

    /** Erstellt einen neuen Loader zum dynamsichen Laden von Komponenten
     * @param componentFactoryResolver ComponentFactoryResolver
     */
    public createDynamicLoader(componentFactoryResolver: ComponentFactoryResolver): DynamicLoader {
        return new DynamicLoader(componentFactoryResolver);
    }
}
